//@ts-check
import {DataTable} from '@/components-v2'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useComboProductTableV2} from '@/hooks/productCombo/useComboProductTableV2'
import {ProductComboSteps} from '@/types/productComboTypes'
import {comboProductTableColumnsWithQuantity} from '@/utils/productCombo/productComboConstants'
import {useMemo} from 'react'
import {ComboReviewSection} from './ComboReviewSection'

const TABLE_PAGE_SIZE = 4

const reviewColumns = comboProductTableColumnsWithQuantity.map(col => ({
  ...col,
  columnKey: col.name_of_db_column,
  header: col.label_of_column,
  columnFilterPlaceholder: col.label_of_column,
}))

export const ComboReviewProducts = () => {
  const {
    productCombo: {comboSkus},
  } = useProductCombo()
  const {
    tableData,
    isFetching,
    onPageIndexChange,
    sortingHandler,
    onColumnFiltersChange,
    pageIndex,
    pageSize,
    totalRowsCount,
    onRowsPerPageChange,
  } = useComboProductTableV2(TABLE_PAGE_SIZE)

  const records = useMemo(() => {
    const quantityByProductId = new Map((comboSkus || []).map(({productId, quantity}) => [productId, quantity]))

    return (tableData || []).map(record => ({
      ...record,
      quantity: quantityByProductId.get(record.productId) ?? record.quantity ?? null,
    }))
  }, [comboSkus, tableData])

  return (
    <ComboReviewSection
      label="Products"
      step={ProductComboSteps.PRODUCTS}
      content={
        <div className="flex w-full flex-col gap-6 overflow-hidden">
          <DataTable
            columns={reviewColumns}
            data={records}
            isLoading={isFetching}
            pageIndex={pageIndex}
            pageSize={pageSize}
            totalRowsCount={totalRowsCount}
            onPageIndexChange={onPageIndexChange}
            manualPagination
            manualSorting
            manualFiltering
            sortingHandler={sortingHandler}
            onColumnFiltersChange={onColumnFiltersChange}
            onRowsPerPageChange={onRowsPerPageChange}
            selection="none"
            enableSorting={false}
            showColumnFilters={false}
            showFilterButton={false}
            showSearchOption={false}
            showTableHeader={false}
            size="small"
          />
        </div>
      }
    />
  )
}
